/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * If selectedFieldsAuto is set to all, all fields will be read.
 * @export
 */
export const SelectedFieldsAutoConfig = {
    SelectedFieldsAll: 'all'
} as const;
export type SelectedFieldsAutoConfig = typeof SelectedFieldsAutoConfig[keyof typeof SelectedFieldsAutoConfig];


export function SelectedFieldsAutoConfigFromJSON(json: any): SelectedFieldsAutoConfig {
    return SelectedFieldsAutoConfigFromJSONTyped(json, false);
}

export function SelectedFieldsAutoConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectedFieldsAutoConfig {
    return json as SelectedFieldsAutoConfig;
}

export function SelectedFieldsAutoConfigToJSON(value?: SelectedFieldsAutoConfig | null): any {
    return value as any;
}

